import styled from '@emotion/styled'

export const CheckBox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
`
